<template>
  <div class="d-flex flex-column mb-15">
    <ReportBaseSelectFilter
      v-if="allTeamsForSelect?.length"
      class="team-filter"
      label="Teams"
      placeholder="All teams"
      query-property="teams"
      :options="allTeamsForSelect"
    />

    <ReportBaseSelectFilter
      v-if="!useLazySelect"
      class="member-filter"
      label="Members"
      placeholder="All members"
      :options="allMembersForSelect"
      :query-property="queryProperty"
    />

    <AppLazySelect
      v-else
      v-model="selected"
      eager
      multiple
      set-state-on-value-change
      class="member-filter"
      resource="member"
      label="Members"
      :fetcher="fetcher"
    >
      <template #item-leading="{ item: user }">
        <AppAvatar
          v-if="user.avatar"
          :avatar="user.avatar"
          size="speck"
        />
      </template>

      <template #item-trailing="{ item: user }">
        <span v-if="user.removed">Removed</span>
      </template>
    </AppLazySelect>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ReportsResource } from '~/resources';

export default {
  name: 'ReportMemberFilter',
  props: {
    queryProperty: {
      type: String,
      default: 'users',
      // This is the default For historical reasons.
      // Make 'members' the default in the future when the majority of report queries expect that
    },
    // Extra filter parameters to be sent to the API
    filterParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      useLazySelect: 'use_lazy_select',
      organizationId: (state) => state.organization_id || state.organization?.id,
    }),
    ...mapGetters(['reportQuery', 'reportStartDate', 'allTeamsForSelect', 'allMembersForSelect']),
    // Only for lazy select
    selected: {
      get() {
        const result = [];

        for (const teamOrUserId of this.reportQuery.filters.users || []) {
          if (typeof teamOrUserId === 'number' || !String(teamOrUserId).includes('team:')) {
            result.push(parseInt(teamOrUserId, 10));
          }
        }

        return result;
      },
      set(userIds = []) {
        this.updateSearch({ [this.queryProperty]: userIds });
      },
    },
  },
  methods: {
    ...mapActions(['updateSearch']),
    fetcher(payload) {
      const finalPayload = {
        ...payload,
        ...this.queryParams,
        filters: {
          ...(payload.filters || {}),
          ...this.filterParams,
          removed_after: this.reportStartDate,
        },
      };

      return ReportsResource.members({ organization_id: this.organizationId }, finalPayload, {
        abortReload: true,
      });
    },
  },
};
</script>
